import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import { toast } from "react-toastify";
import moment from "moment";
import { LiaUserSolid } from "react-icons/lia";
import { MdDateRange, MdOutlineEmail, MdOutlinePhone } from "react-icons/md";
import { GrUserSettings } from "react-icons/gr";

const SubAdminDetail = () => {
  const { id } = useParams()
  const [data, setData] = useState()
  const history = useNavigate()

  useEffect(() => {
    if (id) {
      getDetail();
    }
  }, [id])

  const getDetail = () => {
    loader(true)
    ApiClient.get(`user/profile?id=${id}`).then((res) => {
      if (res?.success) {
        setData(res.data)
      } else {
        toast?.error(res?.message)
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <div className="wrapper_section bg-white shadow-box rounded-lg w-full p-4">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">Sub Admin Details</h3>
            </div>
          </div>



          <div className="flex flex-col gap-y-6">



            
<div className="col-span-12 md:col-span-6">
    <div className="">
      <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold capitalize">
        <span className="inline-flex md:w-96 text-md text-gray-600">First Name:</span>
        
        <LiaUserSolid className="text-xl text-[#F58D18]" />{data?.firstName}
      </p>
    </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Last Name:</span>
        <LiaUserSolid className="text-xl text-[#F58D18]" />{data?.lastName}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Email:</span>
        <MdOutlineEmail className="text-xl text-[#F58D18]" />{data?.email}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Mobile Number:</span>
        <MdOutlinePhone className="text-xl text-[#F58D18]" />{data?.mobileNo ? `+${data?.dialCode + data?.mobileNo}` : "--"}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Role:</span>
        <GrUserSettings className="text-xl text-[#F58D18]" />{data?.role?.name || "--"}
        </p>
      </div>
</div>

<div className="col-span-12 md:col-span-6">
<div className="">
        <p className=" flex md:items-center flex flex-col gap-2 md:flex-row font-semibold">
        <span className="inline-flex md:w-96 text-md text-gray-600">Date:</span>
        <MdDateRange className="text-xl text-[#F58D18]" />{moment(data?.createdAt).format("LL")}
        </p>
      </div>
</div>






</div>



        



        </div>
      </Layout>
    </>
  );
};

export default SubAdminDetail;
